/**
 * Product carousel controls.
 * - data-cbd-scroll-step: page stride (e.g. 2 = move 2 cards)
 * - data-cbd-infinite-swipe: seamless infinite (mobile ranking only; disabled on desktop)
 */
(function () {
  var DESKTOP_MQ = '(min-width: 990px)';

  function getScrollStep(sliderComponent) {
    var raw = parseInt(sliderComponent.getAttribute('data-cbd-scroll-step') || '1', 10);
    return Number.isFinite(raw) && raw > 0 ? raw : 1;
  }

  function getRealSlides(track) {
    return Array.from(track.querySelectorAll('.cbd-product-slider__slide')).filter(function (el) {
      return !el.hasAttribute('data-clone');
    });
  }

  function cloneSlide(slide, position, index) {
    var clone = slide.cloneNode(true);
    clone.dataset.clone = position;
    clone.removeAttribute('id');
    clone.setAttribute('aria-hidden', 'true');
    clone.querySelectorAll('[id]').forEach(function (node) {
      node.removeAttribute('id');
    });
    clone.querySelectorAll('a').forEach(function (link) {
      link.setAttribute('tabindex', '-1');
    });
    clone.classList.add('cbd-product-slider__slide--clone');
    clone.dataset.cloneIndex = String(index);
    return clone;
  }

  function setScrollLeft(track, left, smooth) {
    var prev = track.style.scrollBehavior;
    track.style.scrollBehavior = smooth ? 'smooth' : 'auto';
    track.scrollLeft = left;
    if (!smooth) {
      track.scrollTo({ left: left, behavior: 'auto' });
    }
    requestAnimationFrame(function () {
      track.style.scrollBehavior = prev || '';
    });
  }

  function pageStride(sliderComponent) {
    return (sliderComponent._cbdScrollStep || 1) * (sliderComponent.sliderItemOffset || 0);
  }

  function calcTotalPages(realCount, slidesPerPage, step) {
    if (realCount <= slidesPerPage) return 1;
    return Math.max(1, Math.ceil((realCount - slidesPerPage) / step) + 1);
  }

  function isDesktop() {
    return window.matchMedia(DESKTOP_MQ).matches;
  }

  function goToPage(sliderComponent, page, smooth) {
    var totalPages = sliderComponent.totalPages || 1;
    var safePage = Math.min(Math.max(page, 1), totalPages);
    var loopStart = sliderComponent._cbdLoopStart || 0;
    var left = loopStart + (safePage - 1) * pageStride(sliderComponent);

    if (sliderComponent.slider) {
      setScrollLeft(sliderComponent.slider, left, smooth !== false);
    }
  }

  function syncDots(sliderComponent) {
    var dotsHost = sliderComponent.querySelector('[data-cbd-slider-dots]');
    if (!dotsHost) return;

    // Ranking on desktop: no indicators
    if (sliderComponent.hasAttribute('data-cbd-infinite-swipe') && isDesktop()) {
      dotsHost.innerHTML = '';
      dotsHost.hidden = true;
      sliderComponent.classList.add('cbd-product-slider--single-page');
      return;
    }

    var totalPages = sliderComponent.totalPages || 0;
    var currentPage = sliderComponent.currentPage || 1;

    if (totalPages <= 1) {
      dotsHost.innerHTML = '';
      dotsHost.hidden = true;
      sliderComponent.classList.add('cbd-product-slider--single-page');
      return;
    }

    sliderComponent.classList.remove('cbd-product-slider--single-page');
    dotsHost.hidden = false;

    if (dotsHost.dataset.pages !== String(totalPages)) {
      dotsHost.dataset.pages = String(totalPages);
      dotsHost.innerHTML = '';

      for (var page = 1; page <= totalPages; page += 1) {
        (function (pageIndex) {
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'slider-counter__link slider-counter__link--dots';
          button.setAttribute('aria-label', 'ページ ' + pageIndex);
          button.setAttribute('aria-controls', sliderComponent.slider ? sliderComponent.slider.id : '');
          button.innerHTML = '<span class="dot" aria-hidden="true"></span>';
          button.addEventListener('click', function () {
            goToPage(sliderComponent, pageIndex, true);
          });
          dotsHost.appendChild(button);
        })(page);
      }
    }

    var activePage = Math.min(Math.max(currentPage, 1), totalPages);
    dotsHost.querySelectorAll('.slider-counter__link').forEach(function (link, index) {
      link.classList.toggle('slider-counter__link--active', index + 1 === activePage);
    });
  }

  function updateNavDisabled(sliderComponent) {
    if (!sliderComponent.prevButton || !sliderComponent.nextButton) return;

    // Infinite (mobile ranking): never disable
    if (sliderComponent._cbdInfinite) {
      sliderComponent.prevButton.removeAttribute('disabled');
      sliderComponent.nextButton.removeAttribute('disabled');
      return;
    }

    // Desktop ranking / single page
    if (sliderComponent.totalPages <= 1) {
      sliderComponent.prevButton.setAttribute('disabled', 'disabled');
      sliderComponent.nextButton.setAttribute('disabled', 'disabled');
      return;
    }

    var page = sliderComponent.currentPage || 1;
    if (page <= 1) {
      sliderComponent.prevButton.setAttribute('disabled', 'disabled');
    } else {
      sliderComponent.prevButton.removeAttribute('disabled');
    }

    if (page >= sliderComponent.totalPages) {
      sliderComponent.nextButton.setAttribute('disabled', 'disabled');
    } else {
      sliderComponent.nextButton.removeAttribute('disabled');
    }
  }

  function bindNav(sliderComponent) {
    var onNavClick = function (event) {
      if (!sliderComponent.totalPages || sliderComponent.totalPages <= 1) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var currentPage = sliderComponent.currentPage || 1;
      var totalPages = sliderComponent.totalPages;
      var name = event.currentTarget.name;

      if (sliderComponent._cbdInfinite) {
        var stride = pageStride(sliderComponent);
        var delta = name === 'next' ? stride : -stride;
        setScrollLeft(sliderComponent.slider, sliderComponent.slider.scrollLeft + delta, true);
        return;
      }

      // Non-infinite: stop at ends (no wrap)
      if (name === 'next' && currentPage < totalPages) {
        goToPage(sliderComponent, currentPage + 1, true);
      } else if (name === 'previous' && currentPage > 1) {
        goToPage(sliderComponent, currentPage - 1, true);
      }
    };

    if (sliderComponent.prevButton) {
      sliderComponent.prevButton.addEventListener('click', onNavClick, true);
    }
    if (sliderComponent.nextButton) {
      sliderComponent.nextButton.addEventListener('click', onNavClick, true);
    }
  }

  function measureSlides(sliderComponent) {
    var track = sliderComponent.slider;
    var reals = getRealSlides(track).filter(function (el) {
      return el.clientWidth > 0;
    });

    sliderComponent.sliderItems = reals;
    sliderComponent.sliderItemsToShow = reals;
    sliderComponent._cbdScrollStep = getScrollStep(sliderComponent);

    if (reals.length < 2) {
      sliderComponent.totalPages = 1;
      sliderComponent.currentPage = 1;
      sliderComponent.sliderItemOffset = 0;
      return reals;
    }

    sliderComponent.sliderItemOffset = reals[1].offsetLeft - reals[0].offsetLeft;
    sliderComponent.slidesPerPage = Math.max(
      1,
      Math.floor(track.clientWidth / Math.max(sliderComponent.sliderItemOffset, 1))
    );
    sliderComponent.totalPages = calcTotalPages(
      reals.length,
      sliderComponent.slidesPerPage,
      sliderComponent._cbdScrollStep
    );
    return reals;
  }

  function updatePageFromScroll(sliderComponent) {
    var track = sliderComponent.slider;
    var stride = pageStride(sliderComponent) || 1;
    var loopStart = sliderComponent._cbdLoopStart || 0;
    var loopWidth = sliderComponent._cbdLoopWidth || 0;
    var relative = track.scrollLeft - loopStart;

    if (sliderComponent._cbdInfinite && loopWidth > 0) {
      relative = ((relative % loopWidth) + loopWidth) % loopWidth;
    }

    var previousPage = sliderComponent.currentPage;
    sliderComponent.currentPage = Math.round(relative / stride) + 1;

    if (sliderComponent.totalPages) {
      if (sliderComponent.currentPage < 1) sliderComponent.currentPage = 1;
      if (sliderComponent.currentPage > sliderComponent.totalPages) {
        sliderComponent.currentPage = sliderComponent.totalPages;
      }
    }

    if (sliderComponent.currentPage !== previousPage) {
      sliderComponent.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: { currentPage: sliderComponent.currentPage },
        })
      );
    }

    updateNavDisabled(sliderComponent);
  }

  /** Paged slider without infinite loop (new arrivals). */
  function setupPagedSlider(sliderComponent) {
    var track = sliderComponent.slider;
    if (!track) return;

    var snapTimer = null;
    sliderComponent._cbdInfinite = false;
    sliderComponent._cbdLoopStart = 0;
    sliderComponent._cbdLoopWidth = 0;
    sliderComponent.enableSliderLooping = false;

    function refresh() {
      // Remove any leftover clones
      track.querySelectorAll('[data-clone]').forEach(function (node) {
        node.remove();
      });
      measureSlides(sliderComponent);
      updatePageFromScroll(sliderComponent);
      syncDots(sliderComponent);
      updateNavDisabled(sliderComponent);
    }

    function snapToPage() {
      if ((sliderComponent._cbdScrollStep || 1) <= 1) return;
      var stride = pageStride(sliderComponent);
      if (stride <= 0) return;

      var page = Math.round(track.scrollLeft / stride) + 1;
      page = Math.min(Math.max(page, 1), sliderComponent.totalPages || 1);
      var target = (page - 1) * stride;
      if (Math.abs(track.scrollLeft - target) > 3) {
        goToPage(sliderComponent, page, true);
      } else {
        updatePageFromScroll(sliderComponent);
        syncDots(sliderComponent);
      }
    }

    refresh();

    sliderComponent.initPages = refresh;
    sliderComponent.update = function () {
      updatePageFromScroll(sliderComponent);
      syncDots(sliderComponent);
    };
    sliderComponent.setSlidePosition = function (position) {
      setScrollLeft(track, position, true);
    };

    track.addEventListener(
      'scroll',
      function () {
        updatePageFromScroll(sliderComponent);
        syncDots(sliderComponent);
        if ((sliderComponent._cbdScrollStep || 1) > 1) {
          clearTimeout(snapTimer);
          snapTimer = setTimeout(snapToPage, 90);
        }
      },
      { passive: true }
    );
  }

  /** Seamless infinite — used by ranking on mobile only. */
  function setupInfiniteSwipe(sliderComponent) {
    var track = sliderComponent.slider;
    if (!track) return;

    var jumping = false;

    function removeClones() {
      track.querySelectorAll('[data-clone]').forEach(function (node) {
        node.remove();
      });
    }

    function setDesktopStatic() {
      removeClones();
      sliderComponent._cbdInfinite = false;
      sliderComponent._cbdLoopStart = 0;
      sliderComponent._cbdLoopWidth = 0;
      setScrollLeft(track, 0, false);
      measureSlides(sliderComponent);
      sliderComponent.totalPages = 1;
      sliderComponent.currentPage = 1;
      sliderComponent.classList.add('cbd-product-slider--single-page');
      syncDots(sliderComponent);
      updateNavDisabled(sliderComponent);
    }

    function rebuildMobileInfinite() {
      removeClones();
      sliderComponent._cbdInfinite = false;
      sliderComponent._cbdLoopStart = 0;
      sliderComponent._cbdLoopWidth = 0;

      var reals = getRealSlides(track).filter(function (el) {
        return el.clientWidth > 0;
      });
      if (reals.length < 2) {
        measureSlides(sliderComponent);
        syncDots(sliderComponent);
        return;
      }

      var itemOffset = reals[1].offsetLeft - reals[0].offsetLeft;
      if (itemOffset <= 0) return;

      var slidesPerPage = Math.max(1, Math.floor(track.clientWidth / itemOffset));
      var step = getScrollStep(sliderComponent);
      var totalPages = calcTotalPages(reals.length, slidesPerPage, step);

      if (totalPages <= 1 || track.scrollWidth <= track.clientWidth + 2) {
        measureSlides(sliderComponent);
        syncDots(sliderComponent);
        updateNavDisabled(sliderComponent);
        return;
      }

      var before = reals.map(function (slide, index) {
        return cloneSlide(slide, 'before', index);
      });
      var after = reals.map(function (slide, index) {
        return cloneSlide(slide, 'after', index);
      });

      reals[0].before.apply(reals[0], before);
      var realsNow = getRealSlides(track);
      realsNow[realsNow.length - 1].after.apply(realsNow[realsNow.length - 1], after);

      var firstReal = getRealSlides(track)[0];
      var firstAfter = track.querySelector('[data-clone="after"]');
      if (!firstReal || !firstAfter) return;

      sliderComponent._cbdLoopStart = firstReal.offsetLeft;
      sliderComponent._cbdLoopWidth = firstAfter.offsetLeft - firstReal.offsetLeft;
      sliderComponent._cbdInfinite = sliderComponent._cbdLoopWidth > 0;
      sliderComponent.enableSliderLooping = true;

      measureSlides(sliderComponent);

      if (sliderComponent._cbdInfinite) {
        setScrollLeft(track, sliderComponent._cbdLoopStart, false);
        requestAnimationFrame(function () {
          var firstAfterNode = track.querySelector('[data-clone="after"]');
          var firstRealNode = getRealSlides(track)[0];
          if (firstRealNode && firstAfterNode) {
            sliderComponent._cbdLoopWidth = firstAfterNode.offsetLeft - firstRealNode.offsetLeft;
            sliderComponent._cbdLoopStart = firstRealNode.offsetLeft;
          }
          setScrollLeft(track, sliderComponent._cbdLoopStart, false);
          sliderComponent.currentPage = 1;
          syncDots(sliderComponent);
          updateNavDisabled(sliderComponent);
        });
      }
    }

    function normalizeScroll() {
      if (jumping || !sliderComponent._cbdInfinite) return;
      var loopStart = sliderComponent._cbdLoopStart || 0;
      var loopWidth = sliderComponent._cbdLoopWidth || 0;
      if (loopWidth <= 0) return;

      var x = track.scrollLeft;
      if (x >= loopStart + loopWidth - 1) {
        jumping = true;
        setScrollLeft(track, x - loopWidth, false);
        jumping = false;
        return;
      }
      if (x <= loopStart - loopWidth + 1 || x < 1) {
        jumping = true;
        setScrollLeft(track, x + loopWidth, false);
        jumping = false;
      }
    }

    function refresh() {
      if (isDesktop()) {
        setDesktopStatic();
      } else {
        rebuildMobileInfinite();
        updatePageFromScroll(sliderComponent);
        syncDots(sliderComponent);
        updateNavDisabled(sliderComponent);
      }
    }

    refresh();

    sliderComponent.initPages = refresh;
    sliderComponent.update = function () {
      if (isDesktop()) return;
      normalizeScroll();
      updatePageFromScroll(sliderComponent);
      syncDots(sliderComponent);
    };
    sliderComponent.setSlidePosition = function (position) {
      setScrollLeft(track, position, true);
    };

    track.addEventListener(
      'scroll',
      function () {
        if (jumping || isDesktop()) return;
        normalizeScroll();
        updatePageFromScroll(sliderComponent);
        syncDots(sliderComponent);
      },
      { passive: true }
    );

    window.matchMedia(DESKTOP_MQ).addEventListener('change', refresh);
  }

  function enhance(sliderComponent) {
    if (!(sliderComponent instanceof HTMLElement)) return;
    if (sliderComponent.dataset.cbdSliderEnhanced === 'true') {
      syncDots(sliderComponent);
      return;
    }
    sliderComponent.dataset.cbdSliderEnhanced = 'true';

    bindNav(sliderComponent);

    if (sliderComponent.hasAttribute('data-cbd-infinite-swipe')) {
      setupInfiniteSwipe(sliderComponent);
    } else {
      setupPagedSlider(sliderComponent);
    }
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('slider-component.cbd-product-slider').forEach(enhance);
  }

  function boot() {
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('slider-component').then(function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
